import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'bk-empty-state',
  templateUrl: './bk-empty-state.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BkEmptyStateComponent {
  // Must exist in the vendored MDI 1.8.36 subset (post-2016 names render blank).
  @Input() icon = 'mdi-inbox';
  @Input() message = 'No matching records found';
}
